import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  background: ${({ theme }) => theme.colors.gray};
  color: white;
  font-size: 25px;
  font-family: 'Mangueira bold';
  line-height: 1;
`;
